export default "__VITE_ASSET__Bk91mgZ6__"